export const LIKELIHOODS = {
    very_unlikely: 'Very unlikely',
    unlikely: 'Unlikely',
    possible: 'Possible',
    likely: 'Likely',
    very_likely: 'Very likely',
};
